import * as moment from "moment-timezone";

export interface FilterType {
  inbox: string;
  sender: string;
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
  includeExpired: boolean;
  includeUnmapped: boolean;
  state: string;
  client: number | "all";
  role: number | "all";
  venue: number | "all";
}

/**
 * Return the default filter state
 */
export function getDefaultFilterState(): FilterType {
  return {
    inbox: "",
    sender: "",
    startDate: null,
    endDate: null,
    includeExpired: true,
    includeUnmapped: false,
    state: "all",
    client: "all",
    role: "all",
    venue: "all",
  };
}

/**
 * Return the saved filter state
 */
export function getSavedFilterState(): FilterType {
  // see if localstorage has saved filters
  const savedFilters = localStorage.getItem("shiftStreamEmailFilters");
  if (savedFilters) {
    try {
      const parsedFilters = JSON.parse(savedFilters);

      if (parsedFilters.startDate) {
        const startMoment = moment(parsedFilters.startDate);
        if (startMoment.isValid()) {
          parsedFilters.startDate = startMoment;
        } else {
          parsedFilters.startDate = null;
        }
      }

      if (parsedFilters.endDate) {
        const endMoment = moment(parsedFilters.endDate);
        if (endMoment.isValid()) {
          parsedFilters.endDate = endMoment;
        } else {
          parsedFilters.endDate = null;
        }
      }

      return { ...getDefaultFilterState(), ...parsedFilters };
    } catch (e) {
      console.error("Error parsing saved filters from localStorage", e);
    }
  }

  return getDefaultFilterState();
}

export function saveFilterState(filters: FilterType) {
  // save to local storage
  localStorage.setItem("shiftStreamEmailFilters", JSON.stringify(filters));
}
